<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div v-if="isFetching">
            <div class="h-350px d-flex justify-content-center align-items-center" >
              <div class="text-center">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">{{ $t("loadingText") }}</span>
                </div>
              </div>
            </div>
          </div>
          <PayslipForm
              v-else
              :user="formData.user"
              :payslip="formData"
              :currency="formData.currency"
              :submit-form="updatePayslip"
              :cancel="cancel"
              :is-loading="submitting"
              :parent-id="id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {defineProps, ref, watch} from 'vue'
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import {useLocales} from "@/composables/locales";
import PayslipForm from "@/Modules/RH/components/Payslip/PayslipForm.vue";
import {usePayslipEnums} from "@/Modules/RH/composables/payslipEnums";

const { locale } = useLocales()
const store = useStore()
const { pensionTypesEnums, payrollTaxStatusEnums } = usePayslipEnums()
const props = defineProps({
  id: {type: String, required: true},
  currency: {type: String, required: true},
  parentId: String,
  user: { type: Object, required: true },
  payslip: {
    type: String,
    required: true
  }
})
const emits = defineEmits('reloadDatatable')
const submitting = ref(false)
const isFetching = ref(false)
const formData = ref({
  payslip_id: "",
  office_id: "",
  user_id: "",
  month: "",
  year: "",
  base_salary: "",
  allowances: [{
    id: "",
    value: 0,
    edited: false
  }],
  others: [{
    id: "",
    value: 0,
    edited: false
  }],
  pensions: [{
    id: "",
    value: 1,
    edited: false
  }],
  taxes: [{
    id: "",
    value: 1,
    edited: false
  }],
  pension_employers: [{
    id: "",
    value: 1,
    edited: false
  }],
  taxe_employers: [{
    id: "",
    value: 1,
    edited: false
  }],
})

watch(() => props.payslip, (value) => {
  if(value) {
    isFetching.value = true
    store.dispatch('payslip/getPayslip', value)
        .then(res => {
          formData.value.user = res.data.data.employee
          formData.value.user_id = res.data.data.employee?.id
          formData.value.office_id = res.data.data.office_id
          formData.value.id = res.data.data.id
          formData.value.year = res.data.data.year
          formData.value.month = res.data.data.month
          formData.value.currency = res.data.data.currency_symbol
          formData.value.base_salary = res.data.data.base_salary
          formData.value.allowances = res.data.data.allowances?.map(el => ({
            id: el.id,
            value: parseFloat(el?.pivot?.value),
            edited: !!el?.pivot?.edited
          }))
          formData.value.others = res.data.data.others?.map(el => ({
            id: el.id,
            value: parseFloat(el?.pivot?.value),
            edited: !!el?.pivot?.edited
          }))

          formData.value.pensions = res.data.data.pensions
              ?.filter(el => el.category === pensionTypesEnums.value.EMPLOYEE_PENSION)
              .map(el => ({
                id: el.id,
                value: parseFloat(el?.pivot?.value),
                edited: !!el?.pivot?.edited
              }))
          formData.value.pension_employers = res.data.data.pensions
              ?.filter(el => el.category === pensionTypesEnums.value.EMPLOYER_PENSION)
              .map(el => ({
                id: el.id,
                value: parseFloat(el?.pivot?.value),
                edited: !!el?.pivot?.edited
              }))
          formData.value.taxes = res.data.data.taxes
              ?.filter(el => el.category === payrollTaxStatusEnums.value.EMPLOYEE_TAXE)
              .map(el => ({
                id: el.id,
                value: parseFloat(el?.pivot?.value),
                edited: !!el?.pivot?.edited
              }))

          formData.value.taxe_employers = res.data.data.taxes
              ?.filter(el => el.category === payrollTaxStatusEnums.value.EMPLOYER_TAXE)
              .map(el => ({
                id: el.id,
                value: parseFloat(el?.pivot?.value),
                edited: !!el?.pivot?.edited
              }))
        })
        .catch()
        .finally(() => isFetching.value = false)
  } else {
    formData.value = null
    formData.value = {}
  }
}, { deep: true })


const cancel = () => {
  if(props.parentId) {
    $(props.parentId).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
  emits('afterCreate')
}
const updatePayslip = () => {
  submitting.value = true
  store.dispatch('payslip/updatePayslip', formData.value)
      .then(res => {
        emits('afterCreate')
        window.toastr['success'](i18n.global.t('payslip.notification.payslip_updated'))
        cancel()
      })
      .catch(err => {
        formData.value = null
      })
      .finally(() => submitting.value = false)
}
</script>


<style scoped>

</style>
